import { useEffect, useState } from 'react';

import { cn } from '@/shared/utils/cn';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
}

export function ResizeHandle({ onMouseDown }: ResizeHandleProps) {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (_e: MouseEvent) => {
      // Keep cursor style active during drag
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      document.body.style.cursor = '';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
    };
  }, [isDragging]);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    document.body.style.cursor = 'col-resize';
    onMouseDown(e);
  };

  return (
    <div
      className={cn(
        'absolute top-0 left-0 z-10 h-full cursor-col-resize border-l-2 border-l-transparent pr-4',
        'group hover:border-l-input',
        isDragging && 'border-l-input',
      )}
      onMouseDown={handleMouseDown}
    >
      <div
        className="-left-1px absolute top-1/2 -translate-x-1/2 -translate-y-1/2"
        aria-label="Resize sidebar"
        role="separator"
        aria-orientation="vertical"
      >
        <div
          className={cn(
            'h-8 w-2 items-center justify-center rounded-full',
            'group-hover:bg-input',
            isDragging && 'bg-input',
          )}
        />
      </div>
    </div>
  );
}
